import { useEffect, useRef } from 'react';

export const useIntersectionObserver = (cb: (...args: any[]) => any) => {
  const targetRef = useRef(null);
  const cbRef = useRef<((...args: any[]) => any) | null>(null);

  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);

  useEffect(() => {
    if (!targetRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.length > 0 && entries[0].isIntersecting) {
          cbRef.current?.();
        }
      },
      { threshold: 1 },
    );

    observer.observe(targetRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return targetRef;
};
